// Readable names for the panel and its messages (RN77, H-3): ids come in `details`, names must come out.
//   worker: the `workers` of the block, then the catalog of workers, then «#id»
//   machine: the reading (the block's device), then the catalog of machines, then «#id»

export const workerFullName = (worker) => [worker.name, worker.surname].filter(Boolean).join(' ')

/**
 * RN77 [A202-16]: a name that already ends in «.» («Laura M.») followed by the «.» of the template gives a single period, in
 * any key and any language. `params` are the values given to `t_`; only the ones that end in «.» are looked at.
 */
export const oneDotAfterNames = (text, params = {}) => {
  if (typeof text !== 'string') return text
  return Object.values(params)
    .filter((value) => typeof value === 'string' && value.endsWith('.'))
    .reduce((result, name) => result.split(`${name}.`).join(name), text)
}

/**
 * `block` = the raw timeline of the machine; `lookupWorkerName(id)` / `lookupDeviceName(id)` give the catalog name ('' if none).
 * The functions it returns are what `MessageCatalog` and the panel use.
 */
export const makeNameResolvers = ({ block, lookupWorkerName = () => '', lookupDeviceName = () => '' }) => {
  const worker = (id) => {
    const inBlock = block.workers.find((candidate) => candidate.id === id)
    return (inBlock && workerFullName(inBlock)) || lookupWorkerName(id) || `#${id}`
  }
  const device = (id) => (block.device.id === id && block.device.name) || lookupDeviceName(id) || `#${id}`
  return { worker, device, workers: (ids) => ids.map(worker).join(', '), devices: (ids) => ids.map(device).join(', ') }
}
